var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/InputPassword/index.tsx";
import React, { memo } from 'react';
import { PasswordInput } from '@adc/parallax-component-library';
import InputErrorField from 'Components/utility/InputErrorField';
const InputPassword = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  placeholder = '',
  onBlur,
  onFocus,
  setFieldValue,
  mt,
  mb,
  autoComplete = 'current-password',
  isDisabled,
  onChangeText,
  testID,
  value,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PasswordInput, Object.assign({
    label: label,
    valid: isInvalid ? 'no' : 'yes',
    onBlur: onBlur,
    onFocus: onFocus,
    ariaLabelExtractor: () => '',
    hideButtonAriaLabelExtractor: () => '',
    autoComplete: autoComplete,
    marginTop: mt,
    marginBottom: mb,
    disabled: isDisabled,
    placeholder: placeholder,
    onChangeText: onChangeText,
    testID: testID
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    value: value
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  })), isInvalid && errorMessage && /*#__PURE__*/React.createElement(InputErrorField, {
    errorMessage: errorMessage,
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }));
});
InputPassword.displayName = 'InputPassword';
export { InputPassword };